export default __webpack_public_path__ + "static/media/default-user.8d49e377.png";